import { createAction, props } from '@ngrx/store';
import { IRfqHistory } from '../models/rfq.models';
import { IAddress, IPointOfContact, ITotals } from '../models/common.models';
import { IApproverData } from '../models/customer.models';
import { ICartVoucher } from '../models/cart.models';
import { IBaseConfig } from '../models/enviroment-delivery-details.model';
import { IConsentCheckbox, IUploadedDocument } from '../models/checkout.models';

export const UpdateSelectedDeliveryAddress = createAction(
  '[Checkout] - Update  Delivery Address',
  props<{payload: any}>(),
);

export const BeginApproversListAction = createAction(
  '[Checkout] - Begin Get Approver List',
);

export const UpdateCheckoutData = createAction(
  '[Checkout] - Update Checkout Data',
  props<{deliveryAddress: any, pointOfContact: any, approver: any, approverComment: string}>(),
);

export const UpdatePOCData = createAction(
  '[Checkout] - Update Checkout Data',
  props<{payload: any}>(),
);

export const SuccessGetApproversListAction = createAction(
  '[Checkout] - Success Get Approvers List',
  props<{payload: any}>(),
);

export const ErrorGetApproversListAction = createAction(
  '[Checkout] - Error Get Approvers List Action',
  props<Error>(),
);

export const PostCheckoutData = createAction(
  '[Checkout] - Begin Post Checkout Data)',
  props<{postCheckoutData: any, cartId: string}>(),
);

export const SuccessPostCheckoutDataAction = createAction(
  '[Checkout] - Success Post Checkout Data',
  props<{responseFromPostCheckout: any}>(),
);

export const GetQuoteRfqHistoryStartDataAction = createAction(
  '[Checkout-quote-history] - Start get quote rfq history Action',
);

export const SuccessGetQuoteRfqHistoryDataAction = createAction(
  '[Checkout-quote-history] - Success Get quote rfq history Action',
  props<{rfqBaseInfo: IRfqHistory}>(),
);

export const setSapPoNumber = createAction(
  '[Customer] - Set sap PO number',
  props<{sapPoNumber: string}>(),
);

export const setOrderEmailCopy = createAction(
  '[Customer] - Set order email copy',
  props<{orderEmailCopy: string}>(),
);

export const addPOUploadDocuments = createAction(
  '[Customer] - Add uploaded PO documents',
  props<{uploadedPoDocuments: IUploadedDocument[]}>(),
);

export const setPOUploadDocumentUploadingInProgress = createAction(
  '[Customer] - Set PO document uploading in progress',
  props<{fileName: string, uploadingInProgress: boolean}>(),
);

export const setPOUploadDocumentUploadSuccess = createAction(
  '[Customer] - Set PO document upload success',
  props<{fileName: string, uploadSuccess: boolean}>(),
);

export const setPOUploadDocumentUploadError = createAction(
  '[Customer] - Set PO document upload error',
  props<{fileName: string, uploadError: string | null}>(),
);

export const clearPOUploadDocuments = createAction(
  '[Customer] - Clear uploaded PO documents',
);

export const clearPurchaseOrderNumber = createAction(
  '[Customer] - Clear purchase order number',
);

export const clearOrderEmailCopy = createAction(
  '[Customer] - Clear order email copy',
);

export const setLoadingDeliveryDetailsAddressData = createAction(
  '[Checkout] - Set loading delivery details address data',
  props<{loadingDeliveryDetailsAddressData: boolean}>(),
);

export const setAvailableShipToAddresses = createAction(
  '[Checkout] - Set available shipTo addresses',
  props<{availableShipToAddresses: IAddress[]}>(),
);

export const setAvailableShipToAddressesIfEmpty = createAction(
  '[Checkout] - Set available shipTo addresses if they are empty',
  props<{availableShipToAddresses: IAddress[]}>(),
);

export const addShipToAddressToAvailableShipToAddresses = createAction(
  '[Checkout] - Add shipTo address to available shipTo addresses',
  props<{shipToAddress: IAddress}>(),
);

export const setPreselectedShipToAddress = createAction(
  '[Checkout] - Set preselected shipTo address',
  props<{preselectedShipToAddress: IAddress}>(),
);

export const setPreselectedShipToAddressIfNoneIsPreselected = createAction(
  '[Checkout] - Set preselected shipTo address if none is preselected',
  props<{preselectedShipToAddress: IAddress}>(),
);

export const setAttentionTo = createAction(
  '[Checkout] - Set attentionTo',
  props<{attentionTo: string}>(),
);

export const setAvailableBillToAddresses = createAction(
  '[Checkout] - Set available billTo addresses',
  props<{availableBillToAddresses: IAddress[]}>(),
);

export const setPreselectedBillToAddress = createAction(
  '[Checkout] - Set preselected billTo address',
  props<{preselectedBillToAddress: IAddress}>(),
);

export const setAvailableShipmentMethods = createAction(
  '[Checkout] - Set available shipment methods',
  props<{availableShipmentMethods: IBaseConfig[]}>(),
);

export const setAvailableShipmentMethodsLoading = createAction(
  '[Checkout] - Set available shipment methods loading',
  props<{availableShipmentMethodsLoading: boolean}>(),
);

export const setDeliveryDetailsFormData = createAction(
  '[Checkout] - Set delivery details form data',
  props<{deliveryDetailsFormData: IPointOfContact}>(),
);

export const setDeliveryDetailsApproverFormData = createAction(
  '[Checkout] - Set delivery details approver form data',
  props<{deliveryDetailsApproverFormData: IApproverData}>(),
);

export const setTaxNumberFormData = createAction(
  '[Checkout] - Set tax number form data',
  props<{taxNumber: string}>(),
);

export const setTermsAndConsentsData = createAction(
  '[Checkout] - Set consent checkboxes data',
  props<{terms: IConsentCheckbox[]}>(),
);

export const resetDeliveryDetailsFormData = createAction(
  '[Checkout] - Reset delivery details form data',
);

export const resetTaxNumberFormData = createAction(
  '[Checkout] - Reset delivery details tax number data',
);

export const resetDeliveryDetailsApproverFormData = createAction(
  '[Checkout] - Reset delivery details approver form data',
);

export const resetCartVouchers = createAction(
  '[Checkout] - Reset cart vouchers',
);

export const setTotalPrices = createAction(
  '[Checkout] - Set delivery details total prices',
  props<{totalPrices: ITotals}>(),
);

export const setIsSaturdayShipmentSelected = createAction(
  '[Checkout] - Set is Saturday shipment selected',
  props<{isSaturdayShipmentSelected: boolean}>(),
);

export const setIsHeavyweightShipmentSetAutomatically = createAction(
  '[Checkout] - Set isHeavyweightShipmentSetAutomatically',
  props<{isHeavyweightShipmentSetAutomatically: boolean}>(),
);

export const resetIsSaturdayShipmentSelected = createAction(
  '[Checkout] - Reset isSaturdayShipmentSelected'
);

export const setTotalPricesLoading = createAction(
  '[Checkout] - Set delivery details total prices loading',
  props<{totalPricesLoading: boolean}>(),
);

export const setCartVouchers = createAction(
  '[Checkout] - Set checkout cart vouchers list',
  props<{cartVouchers: ICartVoucher[]}>(),
);

export const clearPreselectedShipToAddress = createAction(
  '[Checkout] - Clear preselected shipTo address'
);

export const clearPreselectedBillToAddress = createAction(
  '[Checkout] - Clear preselected billTo address'
);
